import { render, staticRenderFns } from "./Auctions.vue?vue&type=template&id=68a0561f&"
import script from "./Auctions.vue?vue&type=script&lang=js&"
export * from "./Auctions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports